import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../shared/auth/auth.guard';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ImeiValidatorComponent } from '../../shared/components/imei-validator/imei-validator.component';
import { CqStepsComponent } from './qc-steps/qc-steps.component';
import { QualityControlOverviewComponent } from './pages/quality-control-overview/quality-control-overview.component';
import { ChecklistQualityControlComponent } from './components/checklist-quality-control/checklist-quality-control.component';
import { ApprovalRejectionComponent } from './components/approval-rejection/approval-rejection.component';

const routes: Routes = [
  {
    path: '',
    component: QualityControlOverviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'processo',
    component: CqStepsComponent,
    children: [
      { path: 'imei', component: ImeiValidatorComponent },
      { path: 'checklist', component: ChecklistQualityControlComponent },
      { path: 'decision', component: ApprovalRejectionComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class QualityControlRoutingModule {}
